module.exports = __webpack_public_path__ + "img/ЗВ-13(КВ)-006-m.7886d2a0.png";